/// <reference path="../typings/index.d.ts" />

import { GridAktiviteter } from './Plan/GridAktiviteter';
import * as _ from "underscore";
import { Popup } from './Plan/Popup';
import { EditAktivitet } from './Plan/EditAktivitet';
import { Utils } from './Utils';

window["initDrift"] = (prosess: string, title: string): void => {
    new DriftGrid('/Drift/Data', prosess, title);
}

class DriftGrid {
    grid: DevExpress.ui.dxDataGrid;
    menu: DevExpress.ui.dxForm;
    selskaper: any;
    brukere: any;
    prosess: string;
    element: string;
    formelm: string;
    formelmEdit: string;
    data: any[];
    brukerEpost: string;
    prosess_navn: string;
    prosesser: any[];

    constructor(url: string, prosess: string, title: string) {
        let self: DriftGrid = this;
        this.prosess = prosess;
        this.formelm = "form_" + title;
        $("#" + title).append('<div id="' + this.formelm + '"></div>');
        this.element = "grid_" + title;
        $("#" + title).append('<div id="' + this.element + '" style="margin-top:10px;"></div>');
        this.formelmEdit = "formEdit_" + title;
        $.get("/Data/Bruker") 
            .done((data) => {
                self.brukere = data;
            })
            .fail(() => {
                DevExpress.ui.notify("Failed to get brukere!", "error", 2000);
            });
        $.get("/Drift/InnloggetBrukerEpost")
            .done((data) => {
                self.brukerEpost = data.epost;
            })
            .fail(() => {
                DevExpress.ui.notify("Failed to get epost!", "error", 2000);
            });

        let fra: any = new Date(new Date().setHours(2, 0, 0));
        let til: any = new Date(new Date().setHours(23, 59, 59));
        var params = {
            fra: fra.toUTCString(),
            til: til.toUTCString(),
            selskapId: null,
            prosess: prosess
        };
        $.getJSON(url, params).done((data) => {
            let extra = Utils.isIE() ? 115 : 105;
            var th = $(".navbar").height() + $("#menuForm").height() + $(".nav-tabs").height() + extra;
            data = self.fixDato(data);
            let newHeight = window.innerHeight - th;
            let rows = Math.round(newHeight / 30) - 2;
            $("#" + self.element).height(newHeight);

            for(var i = 0; i < data.length; i++) {
                data[i].process_navn = data[i].aktivitetsItem.prosess.navn;
            }
            self.data = data;
            var process =  _.find(self.prosesser, (itm: any) => {
                return itm.navn.substring(0,2) === self.prosess;
            });

            if (process) {
                self.prosess_navn = process.navn;
            }
            var gridOptions: DevExpress.ui.dxDataGridOptions = {
                dataSource: data,
                remoteOperations: false,
                rowAlternationEnabled: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnAutoWidth: false,
                scrolling: {
                    showScrollbar: 'always'
                },
                columnChooser: {
                    enabled: true
                },
                columnFixing: {
                    enabled: true
                },
                loadPanel: {
                    text: "Henter data"
                },
                filterRow: {
                    visible: true,
                    applyFilter: "auto"
                },
                headerFilter: {
                    visible: true
                },
                selection: {
                    mode: "single"
                },
                paging: {
                    pageSize: rows,
                }/*,
                stateStoring: {
                    enabled: true,
                    storageKey: 'gridDriftState',
                    type: 'localStorage'
                }*/,
                onRowPrepared: (info: any) => {
                    if (!info || !info.rowType || !info.data || info.rowType === 'header') {
                        return;
                    }
                    if (info.data.kontrollertDatoDrift !== null)
                        info.rowElement.addClass('kontrollert');
                    else
                        Utils.rowPrepare(info);
                },
                onContentReady: (e) => {
                    if (!e.element.find("#antallDiv").length) {
                        var gridHeader = e.element.find('.dx-datagrid-header-panel .dx-toolbar .dx-toolbar-items-container');
                        gridHeader.append('<div id="antallDiv" style="padding: 4px 0 0 3px;"><b>Antall aktiviteter:</b> <span id="antallRader"></span></div>');
                    }
                    e.element.find("#antallRader").text(e.component.option("dataSource").length);
                },
                onRowClick: (e) => {
                    e.jQueryEvent.stopPropagation();
                    var component2 = e.component, prevClickTime2 = component2.lastClickTime;
                    component2.lastClickTime = new Date();
                    if (prevClickTime2 && (component2.lastClickTime - prevClickTime2 < 300)) {
                        let params = self.getParams();
                        new EditAktivitet(e.data, e.data.planId, () => self.refreshGrid(params), true)
                    }
                },
                masterDetail: {
                    enabled: false,
                    template: self.DriftAction.bind(self)
                },
                columns: [
                    {
                        dataField: 'id',
                        caption: 'Id',
                        width: 50
                    },
                    {
                        dataField: 'aktId',
                        caption: 'AktId',
                        width: 60
                    },
                    {
                        caption: 'Kontrollere',
                        dataField: 'plan.kontrollertDato',
                        width: 140,
                        cellTemplate: (cellElement, cellInfo) => {
                            $(cellElement).css('padding', '1px');
                            $(cellElement).attr('title', cellInfo.data.merknader);
                            //debugger;
                            let id = 'btnKontrl_' + cellInfo.data.id;
                            var html = '<div id="' + id + '" title="' + cellInfo.data.merknader + '" />';
                            cellElement.html(html);
                            if (cellInfo.data.kontrollertDatoDrift) {
                                $("#" + id).dxButton({
                                    text: "Angre kontrollere", type: "danger", icon: 'fa fa-square-o', height: 25, width: '100%',
                                    onClick: () => { self.KontrollereEllerAnger(cellInfo.data, "AngreKontrollere") }
                                });          
                            } else if (!cellInfo.data.utgaar) {
                                $("#" + id).dxButton({
                                    text: "Kontrollere", type: "success", icon: 'fa fa-check-square-o', height: 25, width: '100%',
                                    onClick: () => { self.KontrollereEllerAnger(cellInfo.data, "Kontrollere")}
                                });                           
                            }
                        }
                    },
                    {
                        caption: 'Selskap',
                        dataField: 'plan.selskap.beskrivelse',
                        width: 100
                    },
                    {
                        caption: 'Prosess',
                        dataField: 'aktivitetsItem.prosess.navn',
                        width: 100,
                    },
                    {
                        caption: 'Navn',
                        dataField: 'aktivitetsItem.navn',
                        width: 200
                    },
                    {
                        dataField: 'dato',
                        caption: 'Produksjon',
                        dataType: 'date',
                        width: 72
                    },
                    {
                        dataField: 'aktivitetsItem.kjoretid',
                        caption: 'Kjøretid',
                        dataType: 'string',
                        width: 72
                    },
                    {
                        dataField: 'cabOrderNr',
                        caption: 'CAB Order',
                        dataType: 'string',
                        width: 72
                    },
                    {
                        dataField: 'cabBatchId',
                        caption: 'CAB Batch',
                        dataType: 'string',
                        width: 72
                    },                    
                    {
                        caption: 'Kontrollert',
                        dataField: 'kontrollertDatoDrift',
                        dataType: 'date',
                        width: 72
                    },
                    {
                        caption: 'Kontrollert av',
                        dataField: 'kontrollertAvDrift',
                        dataType: 'string',
                        width: 120
                    },
                    {
                        caption: 'Type',
                        dataField: 'beskrivelse',
                        width: 100,
                    },
                    {
                        dataField: 'produksjonsType.navn',
                        caption: 'Produksjonstype',
                        width: 150,
                    },
                    {
                        dataField: 'fakturaGruppe.navn',
                        caption: 'FakturaGruppe',
                        width: 100
                    },
                    {
                        dataField: 'antallPlanlagt',
                        caption: 'Priv. planl.',
                        width: 75,
                    },
                    {
                        dataField: 'antalPlanlagtNaering',
                        caption: 'Nær. planl.',
                        width: 75,
                    },
                    {
                        dataField: 'merknader',
                        caption: 'Merknader',
                        width: 200
                    }
                ],
                showBorders: true
            };
            self.grid = $("#" + self.element).dxDataGrid(gridOptions).dxDataGrid("instance");

            var formData = {
                fra: fra,
                til: til,
                selskapId: null,
                prosess: null,
            };
            var col1 = [
                {
                    dataField: "fra",
                    label: { text: "Produksjons dato fra" },
                    editorType: "dxDateBox",
                    editorOptions: {
                        width: "100%",
                        displayFormat: 'dd.MM.yyyy'
                    }
                }, {
                    dataField: "til",
                    label: { text: "Produksjons dato til" },
                    editorType: "dxDateBox",
                    editorOptions: {
                        width: "100%",
                        displayFormat: 'dd.MM.yyyy'
                    }
                }
            ];
            var col2 = [
                {
                    dataField: "selskapId",
                    editorType: "dxSelectBox",
                    label: { text: "Selskap" },
                    editorOptions: {
                        width: "100%",
                        dataSource: [],
                        displayExpr: "beskrivelse",
                        placeholder: "Velg selskap...",
                        valueExpr: "id"
                    }
                }, {
                    dataField: "prosessId",
                    label: { text: "Prosess" },
                    editorType: "dxSelectBox",
                    editorOptions: {
                        width: "100%",
                        dataSource: [],
                        displayExpr: "navn",
                        placeholder: "Velg Prosess...",
                        onSelectionChanged: (e) => {
                            self.prosess = e.selectedItem.navn == 'Alle' ? null : e.selectedItem.navn;
                        },
                        valueExpr: "id"
                    }
                }
            ];
            var col3 = [
                {
                    editorType: "dxButton",
                    editorOptions: {
                        text: "Søk data",
                        type: "default",
                        icon: 'search',
                        width: 200,
                        onClick: function () {
                            var data = self.menu.option("formData");
                            var params = {
                                fra: data.fra.toUTCString(),
                                til: data.til.toUTCString(),
                                selskapId: data.selskapId,
                                prosess: self.prosess
                            };
                            self.refreshGrid(params);
                        }
                    }
                },
            ];
            var c1 = [
                {
                    itemType: "group",
                    items: col1,
                }, {
                    itemType: "group",
                    items: col2,
                }, {
                    itemType: "group",
                    items: col3,
                }];
            self.menu = $("#" + self.formelm).dxForm({
                colCount: 5,
                items: c1,
                formData
            }).dxForm("instance");

            $.get("/Data/Selskap")
                .done((data) => {
                    var editor: any = self.menu.getEditor("selskapId")
                    editor.option("dataSource", data);
                    self.selskaper = data;
                    data.unshift({
                        id: null,
                        navn: "Alle"
                    });
                })
                .fail(() => {
                    DevExpress.ui.notify("Failed to get selskaper!", "error", 2000);
                });
            $.get("/Data/Prosess")
                .done((data) => {
                    var editor: any = self.menu.getEditor("prosessId")
                    if (data[0]) {
                        data.sort((a, b) => a.navn > b.navn);
                    }
                    data.unshift({
                        id: null,
                        navn: "Alle"
                    });
                    editor.option("dataSource", data);
                })
                .fail(() => {
                    DevExpress.ui.notify("Failed to get prosesser!", "error", 2000);
                });
        }).fail((data) => {
            //$(location).attr('href', '/Home/Tilgang');
        });
    }

    addCustomItem(toolbar) {
        var items = toolbar.option('items');
        var myItem = DevExpress.data.query(items).filter(function (item) {
            return item.name == 'myButton';
        }).toArray();
        if (!myItem.length) {
            items.push({
                location: 'after',
                widget: 'dxButton',
                name: 'myButton',
                options: {
                    text: 'Click me',
                    onClick: function (e) {
                        alert('click');
                    }
                }
            });
            toolbar.option('items', items);
        }
    }

    getParams(): any {
        var data = this.menu.option("formData");
        var params = {
            fra: data.fra.toUTCString(),
            til: data.til.toUTCString(),
            selskapId: data.selskapId,
            prosess: this.prosess
        };
        return params;
    }

    fixDato(data: any): any {
        data.forEach((itm) => {
            itm.dato = new Date(itm.dato.substring(0, 10));
        });
        return data;
    }

    refreshGrid(params) {
        var self = this;
        $.get("/Drift/Data", params)
            .done((data) => {
                self.grid.option("dataSource", this.fixDato(data));
                self.data = data;
                DevExpress.ui.notify("Hented " + data.length + " rader", "success", 2000);
            })
            .fail(() => {
                DevExpress.ui.notify("Get data failed!", "error", 2000);
            });
    }

    openAktivitetEditor(data) {
        alert('aasdf');
    }

    KontrollereEllerAnger(data: any, action: string) {
        var self = this;
        data.dato = new Date(data.dato).toUTCString();
        $.post("/Drift/" + action + "AktivitetDrift", { Id: data.id })
        .done(() => {
            var akt =  _.find(self.data, (itm: any) => { return itm.id === data.id; });
            if (akt) {
                akt.kontrollertDatoDrift = action == 'AngreKontrollere' ? null : new Date();
                akt.kontrollertAvDrift = action == 'AngreKontrollere' ? null : self.brukerEpost;
                self.grid.option("dataSource", self.data);
                //self.grid.refresh();
                DevExpress.ui.notify("Gjennomfort " + action, "success", 2000);       
            }


            /*var data = self.menu.option("formData");
            var params = {
                fra: data.fra.toUTCString(),
                til: data.til.toUTCString(),
                selskapId: data.selskapId
            };
            self.refreshGrid(params);*/
        })
        .fail(() => {
            DevExpress.ui.notify("Feil ved " + action, "error", 2000);
        });
    }

    DriftAction(container, options) {
        var self = this;
        debugger;
        let id = options.data.id;
        let html = '<table><tr>';
        html += '<td><div id="add-' + id + '"></div></td>';
        html += '<td style="padding-left:10px;"><div id="mer-' + id + '"></div></td>';
        html += '</tr></table>';
        $(html).appendTo(container);
        if (options.data.kontrollertDatoDrift == null) {
            $("#add-" + id).dxButton({
                text: "Kontrollere drift...",
                icon: "image",
                type: "success",
                onClick: () => {
                    this.KontrollereEllerAnger(options.data, "Kontrollere");
                }
            }); 
        } else {
            $("#add-" + id).dxButton({
                text: "Angre Kontrollere drift...",
                icon: "image",
                type: "danger",
                onClick: () => {
                    this.KontrollereEllerAnger(options.data, "AngreKontrollere");
                }
            }); 
        }

        if (options.data.merknader != null) {
            $("#mer-" + id).dxTextBox({
                value: options.data.merknader,
                width: container.width()
            });
        }

    }
}



// WEBPACK FOOTER //
// ./TS/Drift.ts